module.exports = "/assets/b0b4bf599b50e8c873fcb57db8d48e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EF.png
// module id = 1334
// module chunks = 0